<template>
  <div>
    <QuotationDeadlineForm
      v-if="formDeadline"
      @submit="submit"
      @cancel="cancelQuotationButton"
      v-model="formDeadline"
      @return="previousStep"
      :readonlyForm="readonlyForm"
      :options-quotation="optionsQuotation"
    />
  </div>
</template>
<script>
import QuotationDeadlineForm from "../components/QuotationDeadlineForm";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";
import { formatIsoDateToDDMMYYYY } from "@/utils/formats.js";
export default {
  name: "QuotationStepDeadline",
  data: () => ({
    formDeadline: null,
    formatIsoDateToDDMMYYYY
  }),
  components: {
    QuotationDeadlineForm
  },
  mixins: [QuotationMixin],
  computed: {
    nextQuotationStep() {
      return {
        name: "quotation step cost",
        step: 5
      };
    },
    previousQuotationStep() {
      return {
        name: "quotation step form resource",
        step: 3
      };
    },
    previousQuotationWithoutRecursalStep() {
      return {
        name: "quotation step resource without recursal",
        step: 3
      };
    }
  },
  mounted() {
    this.formDeadline = { ...this.form };
    this.formDeadline.date = !this.formDeadline.date
      ? this.formatIsoDateToDDMMYYYY(new Date())
      : this.formDeadline.date;
  },
  methods: {
    submit(form) {
      this.$emit(
        "newQuotation",
        this.payloadQuotation(form, this.nextQuotationStep)
      );
    },
    previousStep() {
      // Hoje se a modalidade tiver recursos, devo utilizar this.previousQuotationStep,
      // se não this.previousQuotationWithoutRecursalStep, porém futuramente,
      // pode ter modalidades que mesclam composicao_importancia_segurada, recursos
      // e valor_importancia_segurada, nestes casos, a regra mudará.
      let previous = this.optionsQuotation.recursos.obrigatorio
        ? this.previousQuotationStep
        : this.previousQuotationWithoutRecursalStep;
      this.$emit(
        "updateStep",
        this.payloadQuotation(this.formDeadline, previous)
      );
    }
  },
  props: {
    form: {
      type: Object
    },
    readonlyForm: {
      type: Object
    },
    optionsQuotation: {
      type: Object
    }
  }
};
</script>
<style lang="sass"></style>
